    
    
jQuery(document).ready(function(){
    jQuery('#map-image').maphilight();
    jQuery('.link-area').on('mouseover',function(e){
        var area = jQuery(this).data('area');
        jQuery('.'+area).mouseover();
    }).on('mouseout',function(){
        var area = jQuery(this).data('area');
        jQuery('.'+area).mouseout();
    });
});


function initialize(){

    jQuery(document).ready(function(){
        
    
    var areas_kind = {"powiat":{
            "fillColor": "#CCCCFF",
            "zIndex" : "1",
            "step": 0.05
        },
        "miasto":{
            "fillColor": "#FFCCCC",
            "zIndex" : "10",
            "step": 0.05 
        },
        "gmina_miejska":{
            "fillColor": "#9999FF",
            "zIndex" : "10",
            "step": 0.01
        },
        "miejska":{
            "fillColor": "#9999FF",
            "zIndex" : "10",
            "step": 0.01
        },
        "gmina_wiejska":{
            "fillColor": "#CCFFCC",
            "zIndex" : "4",
            "step": 0.01
        }, 
        "wiejska":{
            "fillColor": "#CCFFCC",
            "zIndex" : "4",
            "step": 0.01
        },
        "gmina_miejsko_wiejska":{
            "fillColor": "#CCFFFF",
            "zIndex" : "8",
            "step": 0.01
        },
        "miejsko_wiejska":{
            "fillColor": "#CCFFFF",
            "zIndex" : "8",
            "step": 0.01
        },
        "miasto_w_gminie_miejsko_wiejskiej":{
            "fillColor": "#FFCCCC",
            "zIndex" : "6",
            "step": 0.01
        }, 
        "obszar_wiejski_w_gminie_miejsko_wiejskiej":{
            "fillColor": "#FFFFCC",
            "zIndex" : "7",
            "step": 0.01
        }};


    //console.log(['urls', urls]);

    var mapOptions = {
        center: new google.maps.LatLng(map_center[0], map_center[1]),
        zoom: 15,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };  
    var map = new google.maps.Map(document.getElementById("map_canvas"), mapOptions);

    var bounds = new google.maps.LatLngBounds();

    var pathes_no = pathes.length;

    var marker =  new google.maps.Marker({});
    var info =  new google.maps.InfoWindow({});

    var areas = [];
    for(var i=0; i < pathes_no; i++){
        
        //if(pathes[i].kind == 'miejsko_wiejska') continue;
        
        var cords = pathes[i].path;

        var area = [];
        Object.keys(cords).map(function( index ){
            var point = cords[index];
                area.push(new google.maps.LatLng( point[0],point[1] ));
                bounds.extend(new google.maps.LatLng( point[0],point[1] ));
        });
        var g_area = new google.maps.Polygon({
            path: area,
            strokeColor: "#009900",
            defaultSettings: {
                fillColor: eval('areas_kind.'+pathes[i].kind+'.fillColor'),
                strokeColor: "#009900"
            },
            fillColor: eval('areas_kind.'+pathes[i].kind+'.fillColor'),
            zIndex: eval('areas_kind.'+pathes[i].kind+'.zIndex'),
            step: eval('areas_kind.'+pathes[i].kind+'.step'),
            strokeOpacity: 0.8,
            strokeWeight: 1,
            fillOpacity: 0.5,
            title: pathes[i].name,
            center: pathes[i].center,
            teryt: pathes[i].teryt
            //zIndex: 99
        });
        g_area.setMap(map);
        areas.push(g_area);
        //console.log(pathes[i].name);
        //console.log(pathes[i].kind); 
        google.maps.event.addListener(g_area, 'mousemove', function(e){
            this.setOptions({strokeColor: "#00FF00", "fillOpacity": "0.75"});
            
            //marker.setMap(map);
            //marker.setPosition(e.latLng);
            //marker.setPosition(new google.maps.LatLng((this.center[0]*1).toFixed(2),(''+this.center[1]).substring(0,5)));
            //marker.setTitle(this.title);
            
            info.open(map);
            info.setPosition({ lat: (e.latLng.lat() + this.step).toFixed(4)*1, lng: e.latLng.lng() });
            info.setContent(this.title);
        });
        
        google.maps.event.addListener(g_area, 'mouseout', function()
        {
            this.setOptions({strokeColor: this.defaultSettings.strokeColor, fillOpacity: "0.5"});
            //info.close();
        });
        google.maps.event.addListener(g_area, 'click', function(e){
              window.location.href = urls[this.teryt];
        });

        map.fitBounds(bounds);
    }
    
        google.maps.event.addListener(info, 'mouseover', function(e){
            this.open(map);
        });
    
    
    function setInfoWindow(title, position){
        info.setPosition(position);
    }
    
    });
}